import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
} from '@material-ui/core';
import { Button, Grid } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const HistoryAddons = ({ addons }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <Grid spacing={2}>
      {addons.length === 0 ? (
        <Button disabled={true}>
          {t('ecommerceBags.fields.bag.addons.empty')}
        </Button>
      ) : (
        <Button
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          {isOpen ? t('$*common.hide') : t('$*common.show')}{' '}
          {t('$*orderFormTabs.addons').toLowerCase()} (
          {addons.map(el => el.quantity).reduce((curr, prev) => prev + curr, 0)}
          )
        </Button>
      )}
      <Collapse in={isOpen} unmountOnExit={true}>
        <List component="ul" disablePadding={true}>
          {addons.map(el => (
            <ListItem key={el['@id']}>
              <ListItemIcon>{el.quantity} X</ListItemIcon>
              <ListItemText primary={el.addon} />
            </ListItem>
          ))}
        </List>
      </Collapse>
    </Grid>
  );
};

export default HistoryAddons;
